import script from "./VisitaDomiciliaria.vue?vue&type=script&setup=true&lang=js"
export * from "./VisitaDomiciliaria.vue?vue&type=script&setup=true&lang=js"

import "./VisitaDomiciliaria.vue?vue&type=style&index=0&id=89fb353e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89fb353e"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';import Ripple from 'quasar/src/directives/ripple/Ripple.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QSpace,QItem,QItemSection,QItemLabel,QSpinnerDots,QBtn,QTooltip});qInstall(script, 'directives', {Ripple});
